import {
  axios
} from './axios'
export default {

  /* 登录*/
  signIn(userData) {
    return axios({
      method: 'post',
      url: '/users/user_login',
      data: userData
    })
  },

  /* 注销登录*/
  logout() {
    return axios({
      url: '/logout/index'
    })
  },

  /* 修改密码*/
  editPsd(data) {
    return axios({
      method: 'post',
      url: '/users/chang_user_pwd',
      data: data
    })
  },

  /* 注销登录*/
  getUserInfo() {
    return axios({
      method: 'post',
      url: '/users/get_user_info'
    })
  },

  /*  重置密码  */
  resetPsd(data) {
    return axios({
      method: 'post',
      url: '/users/reset_user_pwd',
      data: data
    })
  },

  /*  保存设置  */
  saveSet(data) {
    return axios({
      method: 'post',
      url: '/users/save_setvalue',
      data: data
    })
  },

  /* 菜单list  */
  getMeunList(data) {
    return axios({
      method: 'post',
      url: '/users/get_menu_list',
      data: data
    })
  },

  /* 获取年级  */
  getSchoolList(data) {
    return axios({
      method: 'post',
      url: '/school/get_school_grade_list',
      data: data
    })
  },

  /** 获取班级  */
  getSchoolclass(data) {
    return axios({
      method: 'post',
      url: '/school/get_school_class_list',
      data: data
    })
  },

  /** 获取班级  */
  cetateClass(data) {
    return axios({
      method: 'post',
      url: '/school/creat_school_class',
      data: data
    })
  },

  /** 获取学科  */
  getClassList(data) {
    return axios({
      method: 'post',
      url: '/school/get_school_subject_list',
      data: data
    })
  },

  /** 获取教师列表  */
  getTeacher(data) {
    return axios({
      method: 'post',
      url: '/school/get_school_teacher_list',
      data: data,
      loding: "hide"
    })
  },

  /** 获取学科  */
  delClass(data) {
    return axios({
      method: 'post',
      url: '/school/del_school_class',
      data: data
    })
  },

  /** 教师添加编辑  */
  addTeacher(data) {
    return axios({
      method: 'post',
      url: '/school/save_teacher_info',
      data: data
    })
  },

  /** 删除教师  */
  delTeacher(data) {
    return axios({
      method: 'post',
      url: '/school/del_school_teacher',
      data: data
    })
  },

  /** 删除教师  */
  getBasic() {
    return axios({
      method: 'post',
      url: '/users/get_settype_list',
    })
  },

  /** 获取教师  */
  getStudent(data) {
    return axios({
      method: 'post',
      url: '/school/get_school_student_list',
      data: data
    })
  },

  /** 保存学生信息  */
  saveStudent(data) {
    return axios({
      method: 'post',
      url: '/school/save_student_info',
      data: data
    })
  },

  /** 删除学生  */
  delStudent(data) {
    return axios({
      method: 'post',
      url: '/school/del_school_student',
      data: data
    })
  },

  /** 解除家长学生关系  */
  delStudentpare(data) {
    return axios({
      method: 'post',
      url: '/school/del_student_parent',
      data: data
    })
  },

  /** 批量导入学生  */
  stuImport(data) {
    return axios({
      method: 'post',
      url: '/school/import_school_student',
      data: data
    })
  },

  /** 批量导入教师  */
  teachImport(data) {
    return axios({
      method: 'post',
      url: '/school/import_school_teacher',
      data: data
    })
  },
  //导入社团
  import_batch_community(data) {
    return axios({
      method: 'post',
      url: '/school/import_batch_community',
      data: data
    })
  },
  /** 教师分工数据  */
  getTeacherSub(data) {
    return axios({
      method: 'post',
      url: '/school/get_class_subject_list',
      data: data
    })
  },

  /** 获取主题  */
  getThemeCourse(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_stclist',
      data: data
    })
  },

  /** 课程添加  */
  addThemeCourse(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/add_school_course',
      data: data
    })
  },

  /** 课程纲要  */
  sketchCourse(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/save_school_course_sketch',
      data: data
    })
  },

  /** 课程纲要获取  */
  getThemeCourse(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_sketch',
      data: data
    })
  },

  /**课程编辑保存   */
  saveCourseData(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/save_school_course',
      data: data
    })
  },

  /**课程设计保存   */
  saveSchoolCourse(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/save_school_course_data',
      data: data
    })
  },

  /**课程设计获取   */
  getSchoolCourse(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_data',
      data: data
    })
  },

  /* 课程详情  */
  getCourseDel(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_info',
      data: data
    })
  },

  /* 课程分类  */
  getCourseList(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_type',
      data: data
    })
  },

  /* 获取社团校本  */
  getCourseListCom(data) {
    return axios({
      method: 'post',
      url: '/schoolcourse/get_school_course_list',
      data: data
    })
  },

  /* 保存学科信息  */
  saveCourse(data) {
    return axios({
      method: 'post',
      url: '/school/save_teacher_class_subject',
      data: data
    })
  },

  /* 获取学期  */
  getTermList(data) {
    return axios({
      method: 'post',
      url: '/common/get_term_list',
      data: data,
      loding: "hide"
    })
  },

  /* 获取学年  */
  getYearList() {
    return axios({
      method: 'get',
      url: '/common/get_year_list',
    })
  },

  /**课程报名列表   */
  getStudlist(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_sign',
      data: data
    })
  },

  /* 课程报名设置  */
  saveCourseSign(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/save_school_course_sign',
      data: data
    })
  },

  /* 课程报名设置  */
  getLogs(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_usersignlist',
      data: data
    })
  },

  /* 变更职位  */
  changeMeb(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/chag_school_course_member_postion',
      data: data
    })
  },

  /* 复用课程  */
  copyCourse(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/copy_school_course',
      data: data
    })
  },

  /* 报名审核  */
  checkCourse(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/check_school_course_sign',
      data: data
    })
  },

  /* 获取校外教师列表  */
  getOutteacher(data) {
    return axios({
      method: 'post',
      url: '/school/get_school_out_teacher_list',
      data: data
    })
  },

  /* 获取校外教师列表  */
  getOutSct(data) {
    return axios({
      method: 'post',
      url: '/users/get_person_teacher_list',
      data: data
    })
  },

  /* 设置班主任  */
  setClassMaster(data) {
    return axios({
      method: 'post',
      url: '/school/set_school_class_master',
      data: data
    })
  },

  /* 删除班主任  */
  resetClassMaster(data) {
    return axios({
      method: 'post',
      url: '/school/del_school_class_master',
      data: data
    })
  },

  /* 获取媒体列表  */
  getnewsList(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_news_media_list',
      data: data
    })
  },

  /* 获取期末评价  */
  getStevlist(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_thtostuevaluatelist',
      data: data
    })
  },

  /* 获取课程成果  */
  getAchieve(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_honnourlist',
      data: data
    })
  },

  /* 删除荣誉  */
  delHonour(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/del_school_course_honnour',
      data: data
    })
  },

  /* 获取期末总结  */
  getSunmmy(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_comsummarylist',
      data: data
    })
  },

  /* 保存荣誉  */
  saveHonr(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/save_school_course_comhonour',
      data: data
    })
  },

  /* 添加校外教师  */
  addOtTea(data) {
    return axios({
      method: 'post',
      url: '/users/add_person_teacher',
      data: data
    })
  },

  /* 获取课程成果  */
  getAchelist(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_comupactlist',
      data: data
    })
  },

  /* 保存课程成果  */
  saveAchieve(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/save_school_course_comupact',
      data: data
    })
  },

  /* 删除上级活动  */
  delComupact(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/del_school_course_comupact',
      data: data
    })
  },

  /** 获取课程行为  */
  getStcourse(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_target_behavore',
      data: data
    })
  },

  /** 获取学期列表  */
  getCourseyear(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_yearlist',
      data: data
    })
  },

  /** 获取学期成果详情  */
  getDcomupactinfo(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_comupactinfo',
      data: data
    })
  },

  /* 获取学期成果荣誉详情  */
  getHounrList(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_honnourinfo',
      data: data
    })
  },

  /*获取荣誉类型  */
  getHonourType(data) {
    return axios({
      method: 'post',
      url: '/common/get_honour_level_list',
      data: data
    })
  },

  /* 获取学生作品*/
  getStlistPic(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_fruitlist',
      data: data
    })
  },

  /* 获取学生作品详情*/
  getStlistInfo(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_fruitinfo',
      data: data
    })
  },

  /*添加期末总结  */
  addSummy(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/save_school_course_comsummary',
      data: data
    })
  },

  /**获取学生能量记录  */
  getEneryList(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_user_energy_list',
      data: data
    })
  },

  /*  保存期末评价  */
  saveCourseTh(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/save_school_course_thtostuevaluatelist',
      data: data
    })
  },

  /*保存期末 */
  pushCourse(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/push_school_course_thtostuevaluate',
      data: data
    })
  },

  /*  添加学生作品  */
  addCfruit(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/save_school_course_fruit',
      data: data
    })
  },

  /*  删除学生作品  */
  delCfruit(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/del_school_course_fruitinfo',
      data: data
    })
  },

  /*  课程报告  */
  getReport(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_report_list',
      data: data
    })
  },

  /*  用户行为  */
  getBehavior(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_target_behavior',
      data: data
    })
  },

  /*  导入评价标准  */
  exportEvl(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/import_school_course_target_behavior',
      data: data
    })
  },

  /*  获取文章列表  */
  getActicleList(data) {
    return axios({
      method: 'post',
      url: '/common/get_article_title_list',
      data: data
    })
  },

  /*  获取文章详情  */
  getActicleInfo(data) {
    return axios({
      method: 'post',
      url: '/common/get_article_content',
      data: data
    })
  },

  /*  获取学生课程列表  */
  getStClist(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_student_course_list',
      data: data
    })
  },

  /*  获取评论列表  */
  getFruitlist(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_fruitcomment_list',
      data: data
    })
  },

  /*  删除评论列表  */
  delFruitlist(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/del_school_course_fruitcomment',
      data: data
    })
  },

  /*  删除评论列表  */
  getFeedlist() {
    return axios({
      method: 'post',
      url: '/school/get_feedback_list',
    })
  },

  /*  回复评论列表  */
  replyFb(data) {
    return axios({
      method: 'post',
      url: '/school/reply_feedback',
      data: data
    })
  },

  /*  审核课程记录  */
  checkFruit(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/check_school_course_fruit',
      data: data
    })
  },

  /*  审核课程记录  */
  checkFruitCom(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/check_school_course_fruitcomment',
      data: data
    })
  },

  /*  一键导出教师  */
  exportTlist(data) {
    return axios({
      method: 'post',
      url: '/school/import_school_teacher',
      data: data
    })
  },

  /*  学科列表  */
  getSublist(data) {
    return axios({
      method: 'post',
      url: '/schoolcourse/get_school_class_course_list',
      data: data
    })
  },

  /*  教师顶部菜单  */
  getUlist(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_my_course_list',
      data: data
    })
  },

  /*  学科班级  */
  getSubClass(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_teacher_class_course',
      data: data
    })
  },

  /*  归档  */
  fileMember(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/file_school_course_member',
      data: data
    })
  },

  /*  删除  */
  delMember(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/del_school_course_member',
      data: data
    })
  },

  /*  学生名单 添加学生  */
  addMember(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/saveall_school_course_member',
      data: data
    })
  },

  /*  学生名单 添加学生  */
  getSignList(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_signinfo',
      data: data
    })
  },

  /*  巡课报告  */
  getRpcom(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_schoolcourse_check_reportlist',
      data: data
    })
  },

  /*  学校巡课报告  */
  getRplist(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_check_reportlist',
      data: data
    })
  },

  /*  批量设置报名限制  */
  setSignLimit(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/batchset_school_course_signinfo',
      data: data
    })
  },

  /*  学校目标行为  */
  getBehtarget(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_target_list',
      data: data
    })
  },

  /*  学校目标行为  */
  getBehlist(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_target_behavior_list',
      data: data
    })
  },

  /*  学校目标行为  */
  saveBehlist(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/save_school_course_target_behavior',
      data: data
    })
  },

  /*  学校课程目标  */
  saveCourselist(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/save_school_course_target',
      data: data
    })
  },

  /*  学校课程目标  */
  saveClassname(data) {
    return axios({
      method: 'post',
      url: '/school/save_school_class_info',
      data: data
    })
  },

  /*  获取数量  */
  getNumfruit(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_fruitlist_cnt',
      data: data
    })
  },

  /*  获取数量  */
  getNumfruitcom(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_fruitcomment_list_cnt',
      data: data
    })
  },

  /*  获取校本数量  */
  getNumCoursecnt(data) {
    return axios({
      method: 'post',
      url: '/schoolcourse/get_school_course_list_cnt',
      data: data
    })
  },

  /*  获取课程报名数量  */
  getNumsigncnt(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_sign_cnt',
      data: data
    })
  },

  /*  获取延时课程  */
  getDelaylist(data) {
    return axios({
      method: 'post',
      url: '/After/get_plan_list',
      data: data
    })
  },
  /*  获取延时课程  */
  getSplanlist() {
    return axios({
      method: 'post',
      url: '/After/get_school_plan_list',
    })
  },

  /*  删除延时课程  */
  delplan(d) {
    return axios({
      method: 'post',
      url: '/After/del_after_list',
      data: d
    })
  },

  /*  获取延时服务  */
  getDelayhour(data) {
    return axios({
      method: 'post',
      url: '/After/get_class_hour_tj',
      data: data
    })
  },

  /*  获取延时课表  */
  getDelaytab(data) {
    return axios({
      method: 'post',
      url: '/After/get_after_timetable',
      data: data
    })
  },

  /*  获取延时课表  */
  getDelayreword(data) {
    return axios({
      method: 'post',
      url: '/After/get_record_list',
      data: data
    })
  },

  /*  获取延时课表  */
  addPlan(data) {
    return axios({
      method: 'post',
      url: '/After/add_after_plan',
      data: data
    })
  },

  /*  获取延时服务项目  */
  getPlantype() {
    return axios({
      method: 'post',
      url: '/After/get_after_item_list',
    })
  },

  /*  获取延时服务时间  */
  getPlantime(data) {
    return axios({
      method: 'post',
      url: '/After/get_after_servertime',
      data: data
    })
  },
  /*  添加课表内容  */
  addTablelist(data) {
    return axios({
      method: 'post',
      url: '/After/add_after_list',
      data: data,
    })
  },
  /*  添加课表内容  */
  addTablelists(data) {
    return axios({
      method: 'post',
      url: '/After/add_after_list_v2',
      data: data,
    })
  },

  /*  我的课表  */
  myTablelist(data) {
    return axios({
      method: 'post',
      url: '/After/get_my_after_timetable',
      data: data,
    })
  },
  /*  学校服务统计  */
  getShour(data) {
    return axios({
      method: 'post',
      url: '/After/get_school_class_hour_tj',
      data: data,
    })
  },
  /*  教师延时统计  */
  getTlog(data) {
    return axios({
      method: 'post',
      url: '/After/get_teacher_class_hour_tj',
      data: data,
    })
  },

  /*  导出课时统计  */
  exportSlist(data) {
    return axios({
      method: 'post',
      url: '/After/export_school_class_hour_tj',
      data: data,
    })
  },

  /*  导出课时统计  */
  exportRlist(data) {
    return axios({
      method: 'post',
      url: '/After/export_record_list',
      data: data,
    })
  },

  /*  导出课时统计  */
  exportTlist(data) {
    return axios({
      method: 'post',
      url: '/After/export_teacher_class_hour_tj',
      data: data,
    })
  },
  //机构列表
  Sellerget_seller_list(data) {
    return axios({
      method: 'post',
      url: '/Seller/get_seller_list',
      data: data,
    })
  },
  //获取系统课程分类
  Sellerget_syscourse_list(data) {
    return axios({
      method: 'post',
      url: '/Seller/get_syscourse_list',
      data: data,
    })
  },
  //获取机构课程列表
  Sellerget_seller_course_list(data) {
    return axios({
      method: 'post',
      url: '/Seller/get_seller_course_list',
      data: data,
    })
  },
  //获取课程学校选择列表
  Sellerget_course_comcourse_list(data) {
    return axios({
      method: 'post',
      url: '/Seller/get_course_comcourse_list',
      data: data,
    })
  },
  //获取区域社团/校本课列表
  schoolcourseget_area_course_list(data) {
    return axios({
      method: 'post',
      url: '/schoolcourse/get_area_course_list',
      data: data,
    })
  },
  //添加机构课程
  Schoolcourseadd_com_course(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/add_com_course',
      data: data,
    })
  },
  //移除机构课程
  Schoolcourseremove_com_course(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/remove_com_course',
      data: data,
    })
  },
  // 获取当前用户顶级区域id
  usersget_top_area_id(data) {
    return axios({
      method: 'post',
      url: '/users/get_top_area_id',
      data: data,
    })
  },
  // 获取区域信息
  commonget_area_list(data) {
    return axios({
      method: 'post',
      url: '/common/get_area_list',
      data: data,
    })
  },
  // 获取学校列表
  Schoolget_school_list(data) {
    return axios({
      method: 'post',
      url: '/School/get_school_list',
      data: data,
    })
  },
  // 获取学段列表
  commonget_school_level_list(data) {
    return axios({
      method: 'post',
      url: '/common/get_school_level_list',
      data: data,
    })
  },
  // 获取学校班级学科课程列表
  schoolcourseget_school_class_course_list(data) {
    return axios({
      method: 'post',
      url: '/schoolcourse/get_school_class_course_list',
      data: data,
    })
  },
  // 获取学校年级列表
  schoolcourseget_school_grade_list(data) {
    return axios({
      method: 'post',
      url: '/school/get_school_grade_list',
      data: data,
    })
  },
  // 获取学校学科列表
  schoolget_school_subject_list(data) {
    return axios({
      method: 'post',
      url: '/school/get_school_subject_list',
      data: data,
    })
  },
  // 获取学科二维码批次列表
  Schoolcourseget_subject_qrcord_batch_list(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_subject_qrcord_batch_list',
      data: data,
    })
  },
  // 获取学期列表
  commonget_term_list(data) {
    return axios({
      method: 'post',
      url: '/common/get_term_list',
      data: data,
    })
  },
  // 生成课程二维码
  Schoolcoursecreat_subject_qrcord(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/creat_subject_qrcord',
      data: data,
    })
  },
  // 保存批次信息
  Schoolcoursesave_qrcord_batch(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/save_qrcord_batch',
      data: data,
    })
  },
  // 获取社团/校本课列表
  schoolcourseget_school_course_list(data) {
    return axios({
      method: 'post',
      url: '/schoolcourse/get_school_course_list',
      data: data,
    })
  },
  // 获取学校课程二维码批次列表
  Schoolcourseget_course_qrcord_batch_list(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_course_qrcord_batch_list',
      data: data,
    })
  },
  // 生成课程二维码
  Schoolcoursecreat_course_qrcord(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/creat_course_qrcord',
      data: data,
    })
  },
  //导入课程目标行为记录
  Schoolcourseimport_school_course_target_behavior(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/import_school_course_target_behavior',
      data: data,
    })
  },
  //获取缴费明细列表
  Costmoney_list(data) {
    return axios({
      method: 'post',
      url: '/Cost/money_list',
      data: data,
    })
  },
  //获取当前学年所有月
  Costschool_mounth(data) {
    return axios({
      method: 'post',
      url: '/Cost/school_mounth',
      data: data,
    })
  },
  //获取结算单
  Costmony_payment_list(data) {
    return axios({
      method: 'post',
      url: '/Cost/mony_payment_list',
      data: data,
    })
  },
  // 获取我的特色课程列表
  Afterget_my_timetable(data) {
    return axios({
      method: 'post',
      url: '/After/get_my_timetable',
      data: data,
    })
  },
  // 获取我的特色课程表
  Afterget_my_chara_timetable(data) {
    return axios({
      method: 'post',
      url: '/After/get_my_chara_timetable',
      data: data,
    })
  },
  // 获取课后服务费用统计
  Afterget_after_costtj(data) {
    return axios({
      method: 'post',
      url: '/After/get_after_costtj',
      data: data,
    })
  },
  // 获取学校的课后服务费用统计
  Afterget_after_costschooltj(data) {
    return axios({
      method: 'post',
      url: '/After/get_after_costschooltj',
      data: data,
    })
  },
  // 获取课程缴费统计
  Schoolcourseget_com_costtj(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_com_costtj',
      data: data,
    })
  },
  // 获取学校的特色课程缴费统计
  Schoolcourseget_com_costschooltj(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_com_costschooltj',
      data: data,
    })
  },
  // 获取工资结账单详细列表
  Costpayment_detail_list(data) {
    return axios({
      method: 'post',
      url: '/Cost/payment_detail_list',
      data: data,
    })
  },
  //学生课程退费
  Schoolcourserefund_school_course_sign(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/refund_school_course_sign',
      data: data,
    })
  },
  //获取账户数据
  Costmoney_total(data) {
    return axios({
      method: 'post',
      url: '/Cost/money_total',
      data: data,
    })
  },
  //发短信
  commonsend_msgcode(data) {
    return axios({
      method: 'post',
      url: '/common/send_msgcode',
      data: data,
    })
  },
  //结算
  Costpayment_end(data) {
    return axios({
      method: 'post',
      url: '/Cost/payment_end',
      data: data,
    })
  },
  //获取当前学校授权电话信息
  Schoolget_school_info_powertel(data) {
    return axios({
      method: 'post',
      url: '/School/get_school_info_powertel',
      data: data,
    })
  },
  //延时服务报名设置统计
  Afterget_after_date(data) {
    return axios({
      method: 'post',
      url: '/After/get_after_date',
      data: data,
    })
  },
  //延时服务报名设置统计
  Afterget_signset_list(data) {
    return axios({
      method: 'post',
      url: '/After/get_signset_list',
      data: data,
    })
  },
  //年级列表
  Afterget_after_grade(data) {
    return axios({
      method: 'post',
      url: '/After/get_after_grade',
      data: data,
    })
  },
  //延时服务报名设置统计
  Afterget_after_singtj(data) {
    return axios({
      method: 'post',
      url: '/After/get_after_signtj',
      data: data,
    })
  },
  //导出报名学生统计列表
  Afterexport_sign_student(data) {
    return axios({
      method: 'get',
      url: '/After/export_sign_student?set_id=' + data.set_id + '&set_title=' + data.set_title + '&token=' + localStorage.getItem("token")+ '&fb_type=' + data.fb_type,
      data: data,
      loding: "hide"
    })
  },
  //報名學生列表
  Afterget_after_student_list(data) {
    return axios({
      method: 'post',
      url: '/After/get_after_student_list',
      data: data,
    })
  },
  //创建报名设置
  Aftersave_sign(data) {
    return axios({
      method: 'post',
      url: '/After/save_sign',
      data: data,
    })
  },
  //获取报名采集信息列表
  CourseSignInfo_list(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_coursesigninfo_list',
      data: data,
    })
  },
  // 货物服务额呢绒
  getServeData(data) {
    return axios({
      method: 'post',
      url: '/After/get_after_item_set',
      data: data,
    })
  },
  //获取学校收费方式
  getCosttype() {
    return axios({
      method: 'post',
      url: '/After/get_after_cost_type',
    })
  },
  //获取学校收费方式
  getabsentLog(data) {
    return axios({
      method: 'post',
      url: '/After/get_leave_record',
      data: data,
    })
  },
  //请假记录详情
  getAsentdel(data) {
    return axios({
      method: 'post',
      url: '/After/get_stu_Leave_list_v2',
      data: data,
    })
  },
   //请假记录详情
   getAsentdels(data) {
    return axios({
      method: 'post',
      url: '/After/get_stu_Leave_list_v3',
      data: data,
    })
  },
  //请假记录详情
  getEdustatus(data) {
    return axios({
      method: 'post',
      url: '/After/update_after_plan_status',
      data: data,
    })
  },

  // 获取当前学年所有月
  schoolMounth(data) {
    return axios({
      method: 'post',
      url: '/Cost/school_mounth',
      data: data,
    })
  },
  // 延时服务缴费名单
  getafterpaylist(data) {
    return axios({
      method: 'post',
      url: '/Cost/get_after_pay_list',
      data: data,
    })
  },
  // 获取学校延时服务缴费统计
  get_school_after_money_tj(data) {
    return axios({
      method: 'post',
      url: '/Cost/get_school_after_money_tj',
      data: data,
    })
  },
  // 获取退费单详情
  get_after_refund_info(data) {
    return axios({
      method: 'post',
      url: '/Cost/get_after_refund_info',
      data: data,
    })
  },
  // 取消延时服务退费单
  cancel_after_refund(data) {
    return axios({
      method: 'post',
      url: '/Cost/cancel_after_refund',
      data: data,
    })
  },
  // 新增延时服务退费单
  add_after_refund(data) {
    return axios({
      method: 'post',
      url: '/Cost/add_after_refund',
      data: data,
    })
  },
  // 获取学校延时服务结算单
  get_school_settle_list(data) {
    return axios({
      method: 'post',
      url: '/Cost/get_school_settle_list',
      data: data,
    })
  },
  // 获取学校结算单详细列表
  get_school_settle_detail_list(data) {
    return axios({
      method: 'post',
      url: '/Cost/get_school_settle_detail_list',
      data: data,
    })
  },
  // 申请结算
  apply_school_settle(data) {
    return axios({
      method: 'post',
      url: '/Cost/apply_school_settle',
      data: data,
    })
  },
  // 获取学校结算单未确认数量
  get_school_settle_confirm_cnt(data) {
    return axios({
      method: 'post',
      url: '/Cost/get_school_settle_confirm_cnt',
      data: data,
    })
  },
  // 获取工资结算单
  get_settle_list(data) {
    return axios({
      method: 'post',
      url: '/Cost/get_settle_list',
      data: data,
    })
  },
  // 获取工资结算单状态数量
  get_settle_state_cnt(data) {
    return axios({
      method: 'post',
      url: '/Cost/get_settle_state_cnt',
      data: data,
    })
  },
  // 确认结算单
  end_settle(data) {
    return axios({
      method: 'post',
      url: '/Cost/end_settle',
      data: data,
    })
  },
  // 获取结算列表
  get_refund_list(data) {
    return axios({
      method: 'post',
      url: '/Cost/get_refund_list',
      data: data,
    })
  },
  // 确认退费
  end_refund(data) {
    return axios({
      method: 'post',
      url: '/Cost/end_refund',
      data: data,
    })
  },
  // 缴费统计
  after_sign_pay_statistics(data) {
    return axios({
      method: 'post',
      url: '/Cost/after_sign_pay_statistics',
      data: data,
    })
  },
  // 缴费统计详情
  after_sign_pay_statistics_detail(data) {
    return axios({
      method: 'post',
      url: '/Cost/after_sign_pay_statistics_detail',
      data: data,
    })
  },
  // 到处数据
  export_settle_detail(data) {
    return axios({
      method: 'post',
      url: '/Cost/export_settle_detail',
      data: data,
    })
  },
  // 学校端工资详情
  get_settle_record_list(data) {
    return axios({

      method: 'post',
      url: '/Cost/get_settle_record_list',
      data: data,
    })
  },
  //获取学校地理位置
  get_school_List(data) {
    return axios({
      method: 'post',
      url: '/Bigdata2/get_school_List',
      data: data,
    })
  },
  //获取报告册
  getReportList(data) {
    return axios({
      method: 'post',
      url: '/School/getSchoolReportList',
      data: data,
    })
  },


  //获取学校地理位置
  get_school_List(data) {
    return axios({
      method: 'post',
      url: '/Bigdata/get_school_List',
      data: data,
    })
  },

  //获取服务记录月份
  getReportMonth(data) {
    return axios({
      method: 'post',
      url: '/After/get_after_record_by_month',
      data: data,
    })
  },

  //获取服务记录月份
  exportDelaypor(data) {
    return axios({
      method: 'post',
      url: '/After/export_after_statistics',
      data: data,
    })
  },


  //人员参与服务占比
  get_each_after_item_num(data) {
    return axios({
      method: 'post',
      url: '/Bigdata2/get_each_after_item_num',
      token: true,
      data: data,
    })
  },
  // 实时动态
  get_record_detail(data) {
    return axios({
      method: 'post',
      url: '/Bigdata2/get_record_detail',
      data: data,
      token: true,
      loding: "hide"
    })
  },
  // 人员参与服务占比
  get_people_num_join_after(data) {
    return axios({
      method: 'post',
      url: '/Bigdata2/get_people_num_join_after',
      data: data,
      token: true,
      loding: "hide"
    })
  },
  //人员参与课程占比
  get_people_num_join_com(data) {
    return axios({
      method: 'post',
      url: '/Bigdata2/get_people_num_join_com',
      data: data,
      token: true,
      loding: "hide"
    })
  },
  // 服务类型占比
  get_each_after_item_num(data) {
    return axios({
      method: 'post',
      url: '/Bigdata/get_each_after_item_num',
      data: data,
      token: true,
      loding: "hide"
    })
  },
  // 课程类型占比
  get_each_com_type_num(data) {
    return axios({
      method: 'post',
      url: '/Bigdata2/get_each_com_type_num',
      data: data,
      token: true,
      loding: "hide"
    })
  },
  // 今日服务完成度
  get_after_completion(data) {
    return axios({
      method: 'post',
      url: '/Bigdata/get_after_completion',
      data: data,
      token: true,
      loding: "hide"
    })
  },
  //今日服务完成量
  get_after_completion_num(data) {
    return axios({
      method: 'post',
      url: '/Bigdata/get_after_completion_num',
      data: data,
      token: true,
      loding: "hide"
    })
  },
  // 社团数量
  get_com_num_rank(data) {
    return axios({
      method: 'post',
      url: '/Bigdata/get_com_num_rank',
      data: data,
      loding: "hide",
      token: true,
    })
  },
  // 近五日服务人次数
  get_after_obj_num_last_five_day(data) {
    return axios({
      method: 'post',
      url: '/Bigdata/get_after_obj_num_last_five_day',
      data: data,
      token: true,
      loding: "hide"
    })
  },
  // 每个学校详情
  get_each_school_detail(data) {
    return axios({
      method: 'post',
      url: '/Bigdata/get_each_school_detail',
      data: data,
      token: true,
      loding: "hide"
    })
  },

  // 用户查询、
  getUserRole(data) {
    return axios({
      method: 'post',
      url: '/users/get_user_list',
      data: data,
    })
  },
  // 用户信息查询、
  getUserRoleinfo(data) {
    return axios({
      method: 'post',
      url: '/users/get_user_all_detail',
      data: data,
    })
  },

  // 删除服务记录详情
  delservelog(data) {
    return axios({
      method: 'post',
      url: '/After/del_record_to_new_tb',
      data: data,
    })
  },

  // 编辑用户信息
  edituserinfo(data) {
    return axios({
      method: 'post',
      url: '/users/edit_user_baseinfo',
      data: data,
    })
  },
  // 报名设置项目列表
  get_signset_item_list(data) {
    return axios({
      method: 'post',
      url: '/After/get_signset_item_list',
      data: data,
    })
  },
  // 登录学校
  login_school(data) {
    return axios({
      method: 'post',
      url: '/users/login_school',
      data: data,
    })
  },
  //获取学校评比时间
  get_schooleval_date_list(data) {
    return axios({
      method: 'post',
      url: '/School/get_schooleval_date_list',
      data: data,
    })
  },
  // 获取评比区间内学校列表
  get_eval_schoollist(data) {
    return axios({
      method: 'post',
      url: '/School/get_eval_schoollist',
      data: data,
    })
  },
  // 保存学校评比时间区间
  save_schooleval_date(data) {
    return axios({
      method: 'post',
      url: '/School/save_schooleval_date',
      data: data,
    })
  },
  // 获取评比时间列表
  get_comeval_date_list(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_comeval_date_list',
      data: data,
    })
  },
  // 设置时间列表
  save_comeval_date(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/save_comeval_date',
      data: data,
    })
  },
  // 获取社团评比区间内社团列表
  get_comeval_comlist(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_comeval_comlist',
      data: data,
    })
  },
  // 获取学校指数详情
  get_schoolindex_info(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_schoolindex_info',
      data: data,
    })
  },
  // 获取社团指数
  get_comindex_info(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_comindex_info',
      data: data,
    })
  },
  // 保存课程考核分数
  save_comassessment_info(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/save_comassessment_info',
      data: data,
    })
  },
  // 创建学校
  creat_school_info(data) {
    return axios({
      method: 'post',
      url: '/School/creat_school_info',
      data: data,
    })
  },
  // 获取编辑学校
  save_school_info(data) {
    return axios({
      method: 'post',
      url: '/School/save_school_info',
      data: data,
    })
  },
  // 获取学期周次列表
  get_year_week_list(data) {
    return axios({
      method: 'post',
      url: '/common/get_year_week_list',
      data: data,
    })
  },

  // save_comassessment_info(data){
  //   return axios({
  //   method: 'post',
  //     url: '/Schoolcourse/save_schoolassessment_info',
  //     data: data,
  //   })
  // },
  // 获取学校的社团评分
  get_school_comassessment_list(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_comassessment_list',
      data: data,
    })
  },
  // 社团详情实地考核
  get_com_assessment_list(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_com_assessment_list',
      data: data,
    })
  },
  get_after_record_word_static_url(data) {
    return axios({
      method: 'post',
      url: '/After/get_after_record_word_static_url',
      data: data,
    })
  },
  // 获取学校的评分列表
  get_school_assessment_list(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_assessment_list',
      data: data,
    })
  },
  // 教育局保存学校评分
  save_schoolassessment_info(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/save_schoolassessment_info',
      data: data,
    })
  },
  // 教育局获取每个学校的社团
  get_edu_comassessment_list(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_edu_comassessment_list',
      data: data,
    })
  },
  // 受星保存
  save_com_level(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/save_com_level',
      data: data,
    })
  },
  // 获取教育局下学校列表
  get_edu_school_list(data) {
    return axios({
      method: 'post',
      url: '/School/get_edu_school_list',
      data: data,
    })
  },
  // 编辑保存学校扩展信息
  save_school_ext(data) {
    return axios({
      method: 'post',
      url: '/School/save_school_ext',
      data: data,
    })
  },
  // 补卡列表
  get_examine_record_list(data) {
    return axios({
      method: 'post',
      url: '/After/get_examine_record_list',
      data: data,
    })
  },
  //审核补卡
  repair_recoder_status(data) {
    return axios({
      method: 'post',
      url: '/After/repair_recoder_status',
      data: data,
    })
  },
  // 获取分类数量
  get_comeval_comnum(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_comeval_comnum',
      data: data,
    })
  },
  // 撤销评星
  cancel_com_level(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/cancel_com_level',
      data: data,
    })
  },
  // 获取区域内荣誉列表
  get_area_comhonour_list(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_area_comhonour_list',
      data: data,
    })
  },
  // 获取区域上级活动列表
  get_area_comupact_list(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_area_comupact_list',
      data: data,
    })
  },
  //
  get_edu_com_num_by_type(data) {
    return axios({
      method: 'post',
      url: '/Bigdata/get_edu_com_num_by_type',
      data: data,
      token: true,
      loding: "hide"
    })
  },
  get_edu_stu_and_tea_join_com_num(data) {
    return axios({
      method: 'post',
      url: '/Bigdata/get_edu_stu_and_tea_join_com_num',
      data: data,
      token: true,
      loding: "hide"
    })
  },
  get_edu_com_num_and_score_by_small_type(data) {
    return axios({
      method: 'post',
      url: '/Bigdata/get_edu_com_num_and_score_by_small_type',
      data: data,
      token: true,
      loding: "hide"
    })
  },
  get_edu_school_list_by_com_and_score(data) {
    return axios({
      method: 'post',
      url: '/Bigdata/get_edu_school_list_by_com_and_score',
      data: data,
      token: true,
      loding: "hide"
    })
  },
  // 审核荣誉
  check_honour(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/check_honour',
      data: data,
      loding: "hide"
    })
  },
  // 审核活动
  check_upact(data) {
    return axios({
      method: 'post',
      url: '/Schoolcourse/check_upact',
      data: data,
      loding: "hide"
    })
  },
  // 保存先进校
  save_school_honour(data) {
    return axios({
      method: 'post',
      url: '/School/save_school_honour',
      data: data,
      loding: "hide"
    })
  },
  // 取消先进校
  cancel_school_honour(data) {
    return axios({
      method: 'post',
      url: '/School/cancel_school_honour',
      data: data,
      loding: "hide"
    })
  },
  //  获取教育局下课程列表
  get_edu_course_list(data) {
    return axios({
      method: 'post',
      url: '/schoolcourse/get_edu_course_list',
      data: data,
    })
  },
  // 获取区域下课程分类数量
  get_edu_course_type_num(data) {
    return axios({
      method: 'post',
      url: '/schoolcourse/get_edu_course_type_num',
      data: data,
    })
  },
  // 获取二级分类
  get_course_type_second(data) {
    return axios({
      method: 'post',
      url: '/schoolcourse/get_course_type_second',
      data: data,
    })
  },
  // 获取机构课程列表
  get_seller_course_list(data) {
    return axios({
      method: 'post',
      url: '/Seller/get_seller_course_list',
      data: data,
    })
  },
  // 工资详情单
  get_settle_info(data) {
    return axios({
      method: 'post',
      url: '/Cost/get_settle_info',
      data: data,
    })
  },
  // 获取结算单线上线下数量
  get_settle_online_cnt(data) {
    return axios({
      method: 'post',
      url: '/Cost/get_settle_online_cnt',
      data: data,
    })
  },
  // 保存课程
  save_course(data) {
    return axios({
      method: 'post',
      url: '/Seller/save_course',
      data: data,
    })
  },
  // 获取课程一级分类
  get_course_type_first(data) {
    return axios({
      method: 'post',
      url: '/Seller/get_course_type_first',
      data: data,
    })
  },
  // 获取课程二级分类
  get_course_type_second(data) {
    return axios({
      method: 'post',
      url: '/Seller/get_course_type_second',
      data: data,
    })
  },
  // 添加课程章节
  add_course_section(data){
    return axios({
      method: 'post',
      url: '/Seller/add_course_section',
      data: data,
    })
  },
  // 添加课程章节资源
  add_course_section_resource(data){
    return axios({
      method: 'post',
      url: '/Seller/add_course_section_resource',
      data: data,
    })
  },
  // 获取课程详情
  get_course_info(data){
    return axios({
      method: 'post',
      url: '/Seller/get_course_info',
      data: data,
    })
  },
  // 获取章程列表
  get_course_section_list(data){
    return axios({
      method: 'post',
      url: '/Seller/get_course_section_list',
      data: data,
    })
  },
  // 免费试看
  on_off_course_section(data){
    return axios({
      method: 'post',
      url: '/Seller/on_off_course_section',
      data: data,
    })
  },
  // 保存机构合作者
  save_seller_parter_info(data){
    return axios({
      method: 'post',
      url: '/Seller/save_seller_parter_info',
      data: data,
    })
  },
  // 获取机构合作者列表
  get_seller_parter_list(data){
    return axios({
      method: 'post',
      url: '/Seller/get_seller_parter_list',
      data: data,
    })
  },
  // 获取机构合作者授权课程列表
  get_seller_parter_power_list(data){
    return axios({
      method: 'post',
      url: '/Seller/get_seller_parter_power_list',
      data: data,
    })
  },
  // 保存机构合作者授权信息
  save_seller_parter_power_info(data){
    return axios({
      method: 'post',
      url: '/Seller/save_seller_parter_power_info',
      data: data,
    })
  },
  // 保存课程授权
  save_all_seller_parter_power(data){
    return axios({
      method: 'post',
      url: '/Seller/save_all_seller_parter_power',
      data: data,
    })
  },
  // 删除课程
  del_seller_course(data){
    return axios({
      method: 'post',
      url: '/Seller/del_seller_course',
      data: data,
    })
  },
  // 删除单次课程
  del_course_section(data){
    return axios({
      method: 'post',
      url: '/Seller/del_course_section',
      data: data,
    })
  },
  // 获取机构基础信息
  get_seller_info(data){
    return axios({
      method: 'post',
      url: '/Seller/get_seller_info',
      data: data,
    })
  },
  // 编辑机构基础信息
  save_seller_info(data){
    return axios({
      method: 'post',
      url: '/Seller/save_seller_info',
      data: data,
    })
  },
  // 获取教师授权机构
  get_seller_teacher_course_list(data){
    return axios({
      method: 'post',
      url: '/Seller/get_seller_teacher_course_list',
      data: data,
    })
  },

  // 获取教案
  get_course_section_resource(data){
    return axios({
      method: 'post',
      url: '/Seller/get_course_section_resource',
      data: data,
    })
  },
  // 获取教案
  get_teacher_course_info(data){
    return axios({
      method: 'post',
      url: '/Seller/get_teacher_course_info',
      data: data,
    })
  },

  // 终止上传
  deleteFileBlob(data){
    return axios({
      method: 'post',
      url: '/Seller/deleteFileBlob',
      data: data,
    })
  },
  // 批量审核补卡
  bath_repair_recoder_status(data){
    return axios({
      method: 'post',
      url: '/After/bath_repair_recoder_status',
      data: data,
    })
  },
  save_school_course_report(data){
    return axios({
      method: 'post',
      url: '/Schoolcourse/save_school_course_report',
      data: data,
    })
  },
  //获取机构下的教师
  get_seller_teacher_list(data){
    return axios({
      method: 'post',
      url: '/Seller/get_seller_teacher_list',
      data: data,
    })
  },
  //添加合作者
  save_seller_parter_info_v2(data){
    return axios({
      method: 'post',
      url: '/Seller/save_seller_parter_info_v2',
      data: data,
    })
  },
  //授权设置
  save_all_seller_parter_power(data){
    return axios({
      method: 'post',
      url: '/Seller/save_all_seller_parter_power',
      data: data,
    })
  },
  //授权设置
  save_seller_parter_power_info(data){
    return axios({
      method: 'post',
      url: '/Seller/save_seller_parter_power_info',
      data: data,
    })
  } ,
  //合作学校
  get_seller_school_list(data){
    return axios({
      method: 'post',
      url: '/Seller/get_seller_school_list',
      data: data,
    })
  } ,
  //合作学校授权班级
  get_seller_school_course(data){
    return axios({
      method: 'post',
      url: '/Seller/get_seller_school_course',
      data: data,
    })
  } ,
  //取消授权
  cancel_power(data){
    return axios({
      method: 'post',
      url: '/Seller/cancel_power',
      data: data,
    })
  } ,
  //购买记录
  get_seller_course_buy_recorder(data){
    return axios({
      method: 'post',
      url: '/Seller/get_seller_course_buy_recorder',
      data: data,
    })
  } ,
  //获取月份
  get_school_after_item_cost(data){
    return axios({
      method: 'post',
      url: '/After/get_school_after_item_cost',
      data: data,
    })
  } ,
  //服务费
  save_school_after_item_cost(data){
    return axios({
      method: 'post',
      url: '/After/save_school_after_item_cost',
      data: data,
    })
  } ,
  // 服务缴费
  renew_seller_power(data){
    return axios({
      method: 'post',
      url: '/Seller/renew_seller_power',
      data: data,
    })
  } ,
  // 服务缴费
  repair_course_status(data){
    return axios({
      method: 'post',
      url: '/Seller/repair_course_status',
      data: data,
    })
  } ,

  // 服务缴费
  get_course_section_list_class(data){
    return axios({
      method: 'post',
      url: '/Seller/get_course_section_list_class',
      data: data,
    })
  } ,
  // 服务缴费
  get_course_section_resource_class(data){
    return axios({
      method: 'post',
      url: '/Seller/get_course_section_resource_class',
      data: data,
    })
  } ,
  // 心跳检测
  pong_class(){
    return axios({
      method: 'post',
      url: '/Seller/pong_class',
      loding: "hide"
    })
  } ,
  // 课表
  get_after_time_table_v2(data){
    return axios({
      method: 'post',
      url: '/After/get_after_time_table_v2',
      data:data,
      loding: "hide"
    })
  } ,

  // 添加课表
  add_after_list_v2(data){
    return axios({
      method: 'post',
      url: '/After/add_after_list_v2',
      data:data
    })
  } ,

  // 添加课表
  get_after_teacher_v2(data){
    return axios({
      method: 'post',
      url: '/After/get_after_teacher_v2',
      data:data,
      loding: "hide"
    })
  } ,

  // 数据大屏
  get_edu_school_detail(data){
    return axios({
      method: 'post',
      url: '/bigdata2/get_edu_school_detail',
      data:data,
      loding: "hide"
    })
  } ,

  // 数据大屏学校费用详情
  bigdata_get_school_cost(data){
    return axios({
      method: 'post',
      url: '/bigdata/get_school_cost',
      data:data,
      loding: "hide"
    })
  } ,
  // 数据大屏教育局每月费用
  bigdata_get_edu_every_month_cost(data){
    return axios({
      method: 'post',
      url: '/bigdata2/get_edu_every_month_cost',
      data:data,
      loding: "hide"
    })
  } ,
  // 数据大屏教育局费用概览
  bigdata_get_edu_cost(data){
    return axios({
      method: 'post',
      url: '/bigdata2/get_edu_cost',
      data:data,
      loding: "hide"
    })
  } ,
  // 数据大屏折线图
  get_edu_school_join_after_by_month(data){
    return axios({
      method: 'post',
      url: '/bigdata/get_edu_school_join_after_by_month',
      data:data,
      loding: "hide"
    })
  } ,


  // 数据大屏折线图
  get_school_material_list(data){
    return axios({
      method: 'post',
      url: '/School/get_school_material_list',
      data:data,
    })
  } ,
  // 数据大屏折线图
  save_school_after_material(data){
    return axios({
      method: 'post',
      url: '/School/save_school_after_material',
      data:data,
    })
  } ,


  // 数据大屏折线图
  add_after_refund(data){
    return axios({
      method: 'post',
      url: '/Cost/add_after_refund',
      data:data,
    })
  } ,


  // 数据大屏折线图
  add_comsigninfo_refund(data){
    return axios({
      method: 'post',
      url: '/Cost/add_comsigninfo_refund',
      data:data,
    })
  } ,
  // 数据大屏折线图
  add_comsign_refund(data){
    return axios({
      method: 'post',
      url: '/Cost/add_comsign_refund',
      data:data,
    })
  } ,
  // 官网数据设置
  get_active_list(data){
    return axios({
      method: 'post',
      url: '/Site/get_active_list',
      data:data,
    })
  } ,

  // 官网数据设置
  get_active_detail(data){
    return axios({
      method: 'post',
      url: '/Site/get_active_detail',
      data:data,
    })
  } ,
  // 官网数据设置
  get_course_detail(data){
    return axios({
      method: 'post',
      url: '/Site/get_course_detail',
      data:data,
    })
  } ,

  // 官网数据设置
  get_course_list(data){
    return axios({
      method: 'post',
      url: '/Site/get_course_list',
      data:data,
    })
  } ,
  // 官网数据设置
  on_off_site_course(data){
    return axios({
      method: 'post',
      url: '/Site/on_off_site_course',
      data:data,
    })
  } ,
  // 保存官网数据设置
  save_site_course(data){
    return axios({
      method: 'post',
      url: '/Site/save_site_course',
      data:data,
    })
  } ,
      // 保存官网数据设置
  save_activity(data){
    return axios({
      method: 'post',
      url: '/Site/save_activity',
      data:data,
    })
  } ,
  Cost_refund_list(data){
    return axios({
      method: 'post',
      url: '/Cost/get_school_refund_list',
      data:data,
    })
  } ,
  Cost_get_after_pay_list_v2(data){
    return axios({
      method: 'post',
      url: '/Cost/get_after_pay_list_v2',
      data:data,
    })
  } ,
  cost_get_stu_leave_info(data){
    return axios({
      method: 'post',
      url: '/cost/get_stu_leave_info',
      data:data,
    })
  } ,
  Costget_after_refund_day_cnt(data){
    return axios({
      method: 'post',
      url: '/Cost/get_after_refund_day_cnt',
      data:data,
    })
  } ,
  Costadd_after_refund(data){
    return axios({
      method: 'post',
      url: '/Cost/add_after_refund',
      data:data,
    })
  } ,
  Costcancel_after_refund(data){
    return axios({
      method: 'post',
      url: '/Cost/cancel_after_refund',
      data:data,
    })
  } ,
  Costexport_after_sign_pay_statistics(data){
    return axios({
      method: 'get',
      url: '/Cost/export_after_sign_pay_statistics',
      data:data,
    })
  } ,
  After_cancel_Leave(data){
    return axios({
      method: 'post',
      url: '/After/cancel_Leave',
      data:data,
    })
  } ,
  After_leave_calendar(data){
    return axios({
      method: 'post',
      url: '/After/leave_calendar',
      data:data,
    })
  } ,
  After_leave_calendar_detail(data){
    return axios({
      method: 'post',
      url: '/After/leave_calendar_detail',
      data:data,
    })
  } ,
  Cost_get_school_money_list(data){
    return axios({
      method: 'post',
      url: '/Cost/get_school_money_list',
      data:data,
    })
  },
  Cost_get_school_settle_confirm_cnt(data){
    return axios({
      method: 'post',
      url: '/Cost/get_school_settle_confirm_cnt',
      data:data,
    })
  },
  Cost_get_school_last_bank(data){
    return axios({
      method: 'post',
      url: '/Cost/get_school_last_bank',
      data:data,
    })
  },
  Cost_get_settle_info_v2(data){
    return axios({
      method: 'post',
      url: '/Cost/get_settle_info_v2',
      data:data,
    })
  },
  Cost_get_area_school_money_list(data){
    return axios({
      method: 'post',
      url: '/Cost/get_area_school_money_list',
      data:data, 
    })
  },
  Cost_get_area_school_money_online_cnt(data){
    return axios({
      method: 'post',
      url: '/Cost/get_area_school_money_online_cnt',
      data:data, 
    })
  },
  Cost_get_area_school_money_state_cnt(data){
    return axios({
      method: 'post',
      url: '/Cost/get_area_school_money_state_cnt',
      data:data, 
    })
  },
  Cost_export_school_refund_list(data){
    return axios({
      method: 'get',
      url: '/Cost/export_school_refund_list',
      data:data, 
    })
  },
  Cost_confirm_user_cost(data){
    return axios({
      method: 'post',
      url: '/Cost/confirm_user_cost',
      data:data, 
    })
  },
  commonget_school_course_type(data){
    return axios({
      method: 'post',
      url: '/common/get_course_type',
      data:data, 
    })
  },
  Siteget_teacher_bank_list(data){
    return axios({
      method: 'post',
      url: '/Site/get_teacher_bank_list',
      data:data, 
    })
  },
  schoolcourseget_school_course_type_num(data){
    return axios({
      method: 'post',
      url: '/schoolcourse/get_school_course_type_num',
      data:data, 
    })
  },
  //学校课程纲要获取
  get_course_sketch(data){
    return axios({
      method: 'post',
      url: '/Seller/get_course_sketch',
      data:data, 
    })
  },
  //课程纲要保存
  save_course_sketch(data){
    return axios({
      method: 'post',
      url: '/Seller/save_course_sketch',
      data:data, 
    })
  },
  //课程设计获取
  get_course_data(data){
    return axios({
      method: 'post',
      url: '/Seller/get_course_data',
      data:data, 
    })
  },
  //课程设计保存
  save_course_data(data){
    return axios({
      method: 'post',
      url: '/Seller/save_course_data',
      data:data, 
    })
  },
  //根据第三方信息进行登陆
  user_login_third(data){
    return axios({
      method: 'post',
      url: '/users/user_login_third',
      data:data, 
    })
  },
  //根据第三方信息进行登陆
  campus_create_auth(data){
    return axios({
      method: 'post',
      url: '/Common/campus_create_auth',
      data:data, 
    })
  },
  //根据第三方信息进行登陆
  get_corp_suite_jsapi_ticket(data){
    return axios({
      method: 'post',
      url: '/Qyweixin/get_corp_suite_jsapi_ticket',
      data:data, 
    })
  },
  //获取学校信息
  get_school_info(data){
    return axios({
      method: 'post',
      url: '/School/get_school_info',
      data:data, 
    })
  },
  //学校管理员列表
  get_school_admin_user_list(data){
    return axios({
      method: 'post',
      url: '/School/get_school_admin_user_list',
      data:data, 
    })
  },
  //学校管理员列表
  save_school_admin_user(data){
    return axios({
      method: 'post',
      url: '/School/save_school_admin_user',
      data:data, 
    })
  },
  //学校管理员列表
  cancel_school_admin_user(data){
    return axios({
      method: 'post',
      url: '/School/cancel_school_admin_user',
      data:data, 
    })
  },
  //获取课后服务项目--区域
  get_area_after_item_list(data){
    return axios({
      method: 'post',
      url: '/After/get_area_after_item_list',
      data:data, 
    })
  },
  //获取课后服务项目
  get_after_item_list(data){
    return axios({
      method: 'post',
      url: '/After/get_after_item_list',
      data:data, 
    })
  },
  //设置服务类型
  save_after_item_v2(data){
    return axios({
      method: 'post',
      url: '/After/save_after_item_v2',
      data:data, 
    })
  },
  //企业微信老师信息补充
  import_qw_teacher(data){
    return axios({
      method: 'post',
      url: '/school/import_qw_teacher',
      data:data, 
    })
  },
  //生成导入课表模板
  get_after_list_template(data){
    return axios({
      method: 'post',
      url: '/After/get_after_list_template',
      data:data, 
    })
  },
  //延时服务课表-导入
  export_after_list(data){
    return axios({
      method: 'post',
      url: '/After/export_after_list',
      data:data, 
    })
  },
  //获取学校课程记录列表
  get_school_course_fruitlist(data){
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_school_course_fruitlist',
      data:data, 
    })
  },
  //创建试卷
  add_paper(data){
    return axios({
      method: 'post',
      url: '/Paper/add_paper',
      data:data, 
    })
  },
  //获取问卷列表
  get_paper_List(data){
    return axios({
      method: 'post',
      url: '/Paper/get_paper_List',
      data:data, 
    })
  },
  //设置试卷
  set_paper(data){
    return axios({
      method: 'post',
      url: '/Paper/set_paper',
      data:data, 
    })
  },
  //获取试卷详情
  get_paper_info(data){
    return axios({
      method: 'post',
      url: '/Paper/get_paper_info',
      data:data, 
    })
  },
  //结果统计
  get_paper_statistics(data){
    return axios({
      method: 'post',
      url: '/Paper/get_paper_statistics',
      data:data, 
    })
  },
  //导出答卷详情
  export_paper_record(data){
    return axios({
      method: 'post',
      url: '/Paper/export_paper_record',
      data:data, 
    })
  },
  //题目统计
  get_sub_statistics(data){
    return axios({
      method: 'post',
      url: '/Paper/get_sub_statistics',
      data:data, 
    })
  },
  //获取教师课程列表
  get_teacher_course_list(data){
    return axios({
      method: 'post',
      url: '/Schoolcourse/get_teacher_course_list',
      data:data, 
    })
  },
  //导出校园信息化管理数据报告
  export_school_report(data){
    return axios({
      method: 'post',
      url: '/users/export_school_report',
      data:data, 
    })
  },
  //导入课程名单
  import_school_course_member(data){
    return axios({
      method: 'post',
      url: '/Schoolcourse/import_school_course_member',
      data:data, 
    })
  },
  //题目记录列表
  get_sub_record_list(data){
    return axios({
      method: 'post',
      url: '/Paper/get_sub_record_list',
      data:data, 
    })
  },
  //题目记录列表
  export_paper_statistics(data){
    return axios({
      method: 'post',
      url: '/Pager/export_paper_statistics',
      data:data, 
    })
  },
  //题目记录列表
  get_new_course_list(data){
    return axios({
      method: 'post',
      url: '/Seller/get_new_course_list',
      data:data, 
    })
  },
  get_new_course_info(data){
    return axios({
      method: 'post',
      url: '/Seller/get_new_course_info',
      data:data, 
    })
  },
  get_roleown_power_course_list(data){
    return axios({
      method: 'post',
      url: '/Seller/get_roleown_power_course_list',
      data:data, 
    })
  },
  Commonget_banner_list(data){
    return axios({
      method: 'post',
      url: '/Common/get_banner_list',
      data:data, 
    })
  },
  Commonget_banner_position(data){
    return axios({
      method: 'post',
      url: '/Common/get_banner_position',
      data:data, 
    })
  },
  Commonadd_update_banner(data){
    return axios({
      method: 'post',
      url: '/Common/add_update_banner',
      data:data, 
    })
  },
  Commondel_banner(data){
    return axios({
      method: 'post',
      url: '/Common/del_banner',
      data:data, 
    })
  },
  Commonget_article_list(data){
    return axios({
      method: 'post',
      url: '/Common/get_article_list',
      data:data, 
    })
  },
  get_realtime_type_list(data){
    return axios({
      method: 'post',
      url: '/Site/get_realtime_type_list',
      data:data, 
    })
  },
  add_update_article(data){
    return axios({
      method: 'post',
      url: '/Common/add_update_article',
      data:data, 
    })
  },
  del_article(data){
    return axios({
      method: 'post',
      url: '/Common/del_article',
      data:data, 
    })
  },
  add_update_activity(data){
    return axios({
      method: 'post',
      url: '/Common/add_update_activity',
      data:data, 
    })
  },
  Commonget_active_list(data){
    return axios({
      method: 'post',
      url: '/Common/get_active_list',
      data:data, 
    })
  },
  get_article_info(data){
    return axios({
      method: 'post',
      url: '/Common/get_article_info',
      data:data, 
    })
  },
  get_role_list(data){
    return axios({
      method: 'post',
      url: '/Users/get_role_list',
      data:data, 
    })
  },
  addoredit_role(data){
    return axios({
      method: 'post',
      url: '/Users/addoredit_role',
      data:data, 
    })
  },
  del_role(data){
    return axios({
      method: 'post',
      url: '/Users/del_role',
      data:data, 
    })
  },
  get_module_list(data){
    return axios({
      method: 'post',
      url: '/Users/get_module_list',
      data:data, 
    })
  },
  get_module_system(data){
    return axios({
      method: 'post',
      url: '/Users/get_module_system',
      data:data, 
    })
  },
  addoredit_module(data){
    return axios({
      method: 'post',
      url: '/Users/addoredit_module',
      data:data, 
    })
  },
  del_module(data){
    return axios({
      method: 'post',
      url: '/Users/del_module',
      data:data, 
    })
  },
  add_permission(data){
    return axios({
      method: 'post',
      url: '/Users/add_permission',
      data:data, 
    })
  },
  get_site_course_list(data){
    return axios({
      method: 'post',
      url: '/Common/get_site_course_list',
      data:data, 
    })
  },
  schoolget_grade_list(data){
    return axios({
      method: 'post',
      url: '/school/get_grade_list',
      data:data, 
    })
  },
  edit_site_course(data){
    return axios({
      method: 'post',
      url: '/Common/edit_site_course',
      data:data, 
    })
  },
  add_site_course(data){
    return axios({
      method: 'post',
      url: '/Common/add_site_course',
      data:data, 
    })
  },
  get_site_allcourse(data){
    return axios({
      method: 'post',
      url: '/Common/get_site_allcourse',
      data:data, 
    })
  },
  del_site_course(data){
    return axios({
      method: 'post',
      url: '/Common/del_site_course',
      data:data, 
    })
  },
  addoredit_position(data){
    return axios({
      method: 'post',
      url: '/Common/addoredit_position',
      data:data, 
    })
  },
  del_banner_position(data){
    return axios({
      method: 'post',
      url: '/Common/del_banner_position',
      data:data, 
    })
  },
  get_course_type(data){
    return axios({
      method: 'post',
      url: '/Seller/get_course_type',
      data:data, 
    })
  },
  get_school_teacher_course(data){
    return axios({
      method: 'post',
      url: '/Seller/get_school_teacher_course',
      data:data, 
    })
  },
  schoolGradeList(data){
    return axios({
      method: 'post',
      url: '/school/get_school_grade_list',
      data:data, 
    })
  },
  get_tuijian_course_info(data){
    return axios({
      method: 'post',
      url: '/Seller/get_tuijian_course_info',
      data:data, 
    })
  },
  get_school_course_list_for_yanshi(data){
    return axios({
      method: 'post',
      url: '/schoolcourse/get_school_course_list_for_yanshi',
      data:data, 
    })
  },
  copy_after_list(data){
    return axios({
      method: 'post',
      url: '/After/copy_after_list',
      data:data, 
    })
  },
  clear_after_list(data){
    return axios({
      method: 'post',
      url: '/After/clear_after_list',
      data:data, 
    })
  },
  get_seller_teacher_course_info(data){
    return axios({
      method: 'post',
      url: '/seller/get_seller_teacher_course_info',
      data:data, 
    })
  },
  get_province_data_info(data){
    return axios({
      method: 'post',
      url: '/bigdata/get_province_data_info',
      data:data, 
    })
  },
  pull_school_qwinfo(data){
    return axios({
      method: 'post',
      url: '/school/pull_school_qwinfo',
      data:data, 
    })
  },
  add_afterandcomrecord_to_square(data){
    return axios({
      method: 'post',
      url: '/after/add_afterandcomrecord_to_square',
      data:data, 
    })
  },
  get_after_com_comsquare(data){
    return axios({
      method: 'post',
      url: '/after/get_after_com_comsquare',
      data:data, 
    })
  },
  get_afterandcomrecord_info(data){
    return axios({
      method: 'post',
      url: '/after/get_afterandcomrecord_info',
      data:data, 
    })
  },
  get_square_list(data){
    return axios({
      method: 'post',
      url: '/after/get_square_list',
      data:data, 
    })
  },
  del_square_info(data){
    return axios({
      method: 'post',
      url: '/after/del_square_info',
      data:data, 
    })
  },
  del_school_all_teacher(data){
    return axios({
      method: 'post',
      url: '/school/del_school_all_teacher',
      data:data, 
    })
  },
  del_school_all_student(data){
    return axios({
      method: 'post',
      url: '/school/del_school_all_student',
      data:data, 
    })
  },
  get_subject_list(data){
    return axios({
      method: 'post',
      url: '/school/get_subject_list',
      data:data, 
    })
  },
  addoredit_teacher_subject(data){
    return axios({
      method: 'post',
      url: '/school/addoredit_teacher_subject',
      data:data, 
    })
  },
  get_auth_seller_list(data){
    return axios({
      method: 'post',
      url: '/seller/get_auth_seller_list',
      data:data, 
    })
  },
  save_auth_seller(data){
    return axios({
      method: 'post',
      url: '/Seller/save_auth_seller',
      data:data, 
    })
  },
  get_seller_authrecord_list(data){
    return axios({
      method: 'post',
      url: '/seller/get_seller_authrecord_list',
      data:data, 
    })
  },
  get_teacher_authrecord_list(data){
    return axios({
      method: 'post',
      url: '/seller/get_teacher_authrecord_list',
      data:data, 
    })
  },
  get_auth_seller_qualification(data){
    return axios({
      method: 'post',
      url: '/Seller/get_auth_seller_qualification',
      data:data, 
    })
  },
  check_sellerteacher_auth(data){
    return axios({
      method: 'post',
      url: '/seller/check_sellerteacher_auth',
      data:data, 
    })
  },
  get_edu_seller_list(data){
    return axios({
      method: 'post',
      url: '/seller/get_edu_seller_list',
      data:data, 
    })
  },
  get_edu_seller_school_list(data){
    return axios({
      method: 'post',
      url: '/seller/get_edu_seller_school_list',
      data:data, 
    })
  },
  get_act_log_list(data){
    return axios({
      method: 'post',
      url: '/Users/get_act_log_list',
      data:data, 
    })
  },
  get_sitebigcourse_list(data){
    return axios({
      method: 'post',
      url: '/Common/get_sitebigcourse_list',
      data:data, 
    })
  },
  save_sitebigcourse(data){
    return axios({
      method: 'post',
      url: '/Common/save_sitebigcourse',
      data:data, 
    })
  },
  del_sitebigcourse(data){
    return axios({
      method: 'post',
      url: '/Common/del_sitebigcourse',
      data:data, 
    })
  },
  get_sitebigcourse_allcourse_list(data){
    return axios({
      method: 'post',
      url: '/Common/get_sitebigcourse_allcourse_list',
      data:data, 
    })
  },
  del_sitebigcourse_course(data){
    return axios({
      method: 'post',
      url: '/Common/del_sitebigcourse_course',
      data:data, 
    })
  },
  get_sitebigcourse_detail_list(data){
    return axios({
      method: 'post',
      url: '/Common/get_sitebigcourse_detail_list',
      data:data, 
    })
  },
  add_sitebigcourse_course(data){
    return axios({
      method: 'post',
      url: '/Common/add_sitebigcourse_course',
      data:data, 
    })
  },
  eathink_user_logout(data){
    return axios({
      method: 'post',
      url: '/Users/eathink_user_logout',
      data:data, 
    })
  },
  get_school_actualtime_bigdata(data){
    return axios({
      method: 'post',
      url: '/bigdata2/get_school_actualtime_bigdata',
      data:data, 
      loding: "hide"
    })
  },
  get_school_bigdata(data){
    return axios({
      method: 'post',
      url: '/bigdata2/get_school_bigdata',
      data:data, 
      loding: "hide"
    })
  },
  import_school_info(data){
    return axios({
      method: 'post',
      url: '/School/import_school_info',
      data:data, 
      loding: "hide"
    })
  },
  del_signset(data){
    return axios({
      method: 'post',
      url: '/after/del_signset',
      data:data, 
    })
  },
  merge_student_info(data){
    return axios({
      method: 'post',
      url: '/users/merge_student_info',
      data:data, 
    })
  },
  get_area_data_info(data){
    return axios({
      method: 'post',
      url: '/bigdata/get_area_data_info',
      data:data, 
    })
  },
  get_school_data_info(data){
    return axios({
      method: 'post',
      url: '/bigdata/get_school_data_info',
      data:data, 
    })
  },
  get_student_after_item_list(data){
    return axios({
      method: 'post',
      url: '/after/get_student_after_item_list',
      data:data, 
    })
  },
  batch_sign_stuleave(data){
    return axios({
      method: 'post',
      url: '/After/batch_sign_stuleave',
      data:data, 
    })
  },
  get_student_free_config(data){
    return axios({
      method: 'post',
      url: '/after/get_student_free_config',
      data:data, 
    })
  },
  get_user_sign_leave_list(data){
    return axios({
      method: 'post',
      url: '/after/get_user_sign_leave_list',
      data:data, 
    })
  },
  get_after_item_date_list(data){
    return axios({
      method: 'post',
      url: '/after/get_after_item_date_list',
      data:data, 
    })
  },
  save_course_download_info(data){
    return axios({
      method: 'post',
      url: '/seller/save_course_download_info',
      data:data, 
    })
  },
  add_person_teacher(data){
    return axios({
      method: 'post',
      url: '/users/add_person_teacher',
      data:data, 
    })
  },
  del_person_teacher(data){
    return axios({
      method: 'post',
      url: '/users/del_person_teacher',
      data:data, 
    })
  },
  get_person_teacher_list(data){
    return axios({
      method: 'post',
      url: '/users/get_person_teacher_list',
      data:data, 
    })
  },
  add_com_click(data){
    return axios({
      method: 'post',
      url: '/schoolcourse/add_com_click',
      data:data, 
      loding: "hide"
    })
  },
  get_school_check_seller_com_list(data){
    return axios({
      method: 'post',
      url: '/cost/get_school_check_seller_com_list',
      data:data, 
    })
  },
  school_checked_com(data){
    return axios({
      method: 'post',
      url: '/cost/school_checked_com',
      data:data, 
    })
  },
  school_batch_checked_com(data){
    return axios({
      method: 'post',
      url: '/cost/school_batch_checked_com',
      data:data, 
    })
  },
  asyn_zhengqi_school(data){
    return axios({
      method: 'post',
      url: '/common/asyn_zhengqi_school',
      data:data, 
    })
  },
  get_seller_son_settle_list(data){
    return axios({
      method: 'post',
      url: '/cost/get_seller_son_settle_list',
      data:data, 
    })
  },
  get_seller_course_settle(data){
    return axios({
      method: 'post',
      url: '/cost/get_seller_course_settle',
      data:data, 
    })
  },
  get_seller_school_settle_list(data){
    return axios({
      method: 'post',
      url: '/cost/get_seller_school_settle_list',
      data:data, 
    })
  },
  get_seller_course_settle_list(data){
    return axios({
      method: 'post',
      url: '/cost/get_seller_course_settle_list',
      data:data, 
    })
  },
  get_contract_info(data){
    return axios({
      method: 'post',
      url: '/cost/get_contract_info',
      data:data, 
    })
  },
  get_year_month(data){
    return axios({
      method: 'post',
      url: '/common/get_year_month',
      data:data, 
    })
  },
  get_term_list(data) {
    return axios({
      method: 'post',
      url: '/common/get_term_list',
      data: data,
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/index.js